export function gtmPushEvent (eventName, eventObject) {
  const dataLayer = getDataLayer();
  dataLayer.push({'event' : eventName, eventObject});
}

function getDataLayer() {
  if(typeof window == 'undefined') {
    return;
  }

  if(!(window).dataLayer) {
    return console.log('gtm event called but, not exist');
  }

  return window.dataLayer || [];
}